<template>
  <v-container>
        <v-toolbar
          color="white"
          flat class="fixed-bar"
        >
     <v-badge
          color="blue"
          :content="landedloads.length"
          :value="landedloads.length"
          v-if="!listView"
        >
        <v-btn :disabled="landedloads.length === 0" @click="landedLoadsSheet = true"><v-icon>mdi-window-minimize</v-icon>Landed</v-btn>
        </v-badge>

          <v-spacer></v-spacer>

          <v-btn :disabled="flights.length === 0" @click="listView = !listView"><v-icon>mdi-format-list-numbered</v-icon></v-btn>
          <v-btn :disabled="!viewingToday" @click="dialog = true" color="primary" v-if="!listView"><v-icon>mdi-plus</v-icon>Add </v-btn>
        </v-toolbar>
      <ManifestbyInstructorView v-if="listView" :flights="flights"  />
       <v-bottom-sheet v-model="landedLoadsSheet">

          <v-list>
            <v-subheader>Click on a Load to view it</v-subheader>
            <v-list-item
              v-for="f in landedloads"
              :key="f.number"
              @click="maximize(f.id)"
            >

                <v-list-item-avatar>
                  <v-avatar  :color="getColor(f.status)"
                    tile
                  >
                    <!-- <v-icon>mdi-window-maximize</v-icon>  -->
                    <h3>{{ f.number }}</h3>
                  </v-avatar>
                </v-list-item-avatar>
        <v-list-item-content>
              <v-col cols="12" md="6">
                <ul class="load-summary">
                  <li>{{f.pilotName}}</li>
                  <li>{{f.aircraft}}</li>

                  <li>Landed: {{f.land_time}}</li>
                  <li>{{ f.assigned_jumps ?
                    sum(f.assigned_jumps,'instructorW') + sum(f.assigned_jumps,'customerW') + f.pilotWeight : f.pilotWeight }} lb
                  </li>
                  </ul>
              </v-col>
              <v-col cols="12" md="6">

                <v-chip-group
                    column :class="{ landed_group : f.status === 4 || f.status < 1 }"
                    active-class="primary--text"
                  >
                    <v-chip :disabled="true"  v-for="(assigned_jump, j) in f.assigned_jumps" :key="assigned_jump.jumpId"

                              >
                      <span>
                        <strong>{{assigned_jump.code}}</strong>
                            {{ assigned_jump.fullName }}  <br>
                            {{ assigned_jump.instructorName }}
                      </span>

                    </v-chip>
                </v-chip-group>

              </v-col>
        </v-list-item-content>

            </v-list-item>
          </v-list>
        </v-bottom-sheet>


    <v-row>
      <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                  <v-card color="lighten-1">
                      <v-card-text>
                          <v-container>
                              <v-row>
                                  <v-form @submit.prevent="save" ref="form" v-model="valid" class="row">

                                    <v-col  cols="12" md="6">

                                          <v-select
                                          v-model="editedItem.plain_id"
                                          :items="plains"
                                          ref="plain"
                                          label="Aircraft"
                                          item-text="name"
                                          item-value="id"
                                          :value="editedItem.plain_id"
                                          persistent-hint

                                          outlined
                                          hide-details
                                          :rules="plainRules"
                                        ></v-select>
                                    </v-col>
                                      <v-col  cols="12" md="6">
                                              <v-select
                                                v-model="editedItem.pilot_id"
                                                :items="pilots"
                                                ref="pilot"
                                                label="Pilot"
                                                item-text="name"
                                                item-value="id"
                                                :value="editedItem.pilot_id"
                                                persistent-hint
                                                outlined
                                                hide-details
                                                :rules="pilotRules"
                                        ></v-select>
                                      </v-col>

                                  <v-text-field label="Notes" v-model="editedItem.notes"></v-text-field>

                                  </v-form>
                              </v-row>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                          <v-btn color="blue darken-1" type="Submit" @click="save" :disabled="!valid">Save</v-btn>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
    </v-row>

    <v-row v-if="!listView">
      <v-dialog color="white" v-model="selectInstructorBox" @keydown.esc="selectInstructorBox = false" persistent max-width="600px">
        <v-card>

          <v-form @submit.prevent="assignInstructor" v-model="validInstructor">


                      <v-card-text>
                        <strong>{{jump.code}}</strong>
                        <span> {{jump.fullName }} <small>({{jump.customerW}})</small></span>

                                    <v-select
                                    v-model="jump.selectedInstructor"
                                        :items="filteredInstructors"
                                        item-text="name"
                                        item-value="id"
                                        placeholder="instructors"
                                        hide-no-data
                                        :rules="instructorRules"
                                    >
                                     </v-select>
                      </v-card-text>
                  <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeInstBox">Cancel</v-btn>
                          <v-btn color="blue darken-1" type="Submit" :disabled="!validInstructor">Save</v-btn>
                      </v-card-actions>

          </v-form>

        </v-card>
      </v-dialog>
      <v-col
        cols="12"
        md="3"
        lg="3"
      >
        <v-card
          class="pa-2 selectedJumps fixed-bar"
          outlined
          tile
        >

        <v-list-item-group v-model="selectedJumps">
            <template v-for="(item, i) in checkedin">
                  <v-list-item

                    :key="`item-${i}`"
                    :value="item.id"
                    active-class="cyan lighten-3"
                    :disabled="!viewingToday"
                  >
                    <div>
                      <em>{{item.code}}</em>
                      <span> {{item.fullName }} <small>({{item.customerW}})</small></span>

                      <span v-if="item.instructorName !== null" class="instructorName">{{ item.instructorName }} <small>({{ item.instructorW }})</small>

                        <v-btn
                                    @click="removeInstructor(item)"
                                    small
                                    icon
                                    depressed
                                  >

                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>

                      </span>
                    </div>
            </v-list-item>
            </template>
          </v-list-item-group>

        </v-card>
              <v-snackbar
                v-model="snackbar"
              >
                {{ snackbartext }}

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="orange"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>

      </v-col>
      <v-col
        cols="12"
        md="9"
        lg="9"
      >
        <v-card
          class="pa-2"
          outlined
          tile
        >

          <v-item-group v-model="activeLoad">
            <v-row>

                <v-col v-for="(flight, f) in flights"
                :key="`flight-${f}`"
                  :value="flight.id"


                cols="12"
                md="6"
                sm="6"
                lg="4"
              :class="{ hidden : !flight.expand, minified :'minified' } "
              >

              <v-item v-slot:default="{ active, toggle }">

                  <v-card :color="active ? 'cyan lighten-5' : ''"
                    class="pa-2"
                    tile
                     @click="toggle"
                  >

                        <v-app-bar :color="getColor(flight.status)" class="load-title" flat>

                          <v-toolbar-title>
                            <span class="text">LOAD</span> {{flight.number}}
                          </v-toolbar-title>
                          <v-spacer></v-spacer>

                          <v-btn small class="white--text"
                          v-if="flight.status === 4 && checkGate('load-undo')" icon @click="unland(flight.id)"><v-icon>mdi-undo-variant</v-icon></v-btn>

                          <v-btn small class="white--text" v-if="flight.status === 4" icon @click="hide(flight)"><v-icon>mdi-window-minimize</v-icon></v-btn>

                          <v-btn v-if="flight.status <= 3 && flight.status > 0"  small class="ma-2" @click="cancel(flight.id)">
                          <v-icon left>mdi-airplane-off</v-icon> Cancel
                        </v-btn>
                        <StatusChip v-if="flight.status !== 2 && flight.status < 3" :status="flight.status" />
                        </v-app-bar>

                      <v-row>
                          <v-col cols="6" md="6" class="load_info">
                            <span class="aircraft">{{flight.aircraft}}</span>
                            <span class="pilot">{{flight.pilotName}} <small>{{flight.pilotWeight}}</small></span>
                          </v-col>

                          <v-col cols="6" md="6">

                            <v-btn :disabled="!viewingToday" v-if="flight.status < 3 && flight.status > 0 && flight.assigned_jumps !== null && flight.assigned_jumps.length > 0" small color="green" text-color="white"
                            @click="depart(flight.id)"
                            >
                              <v-icon>mdi-airplane-takeoff</v-icon> Depart
                            </v-btn>
                            <time v-else class="depart">{{flight.departed_time ? flight.departed_time : ' --:--'}}</time>

                            <v-btn :loading="sendingEmail" :disabled="!viewingToday " @click="land(flight.id)" v-if="flight.status === 3" small color="green lighten-5" text-color="light-green darken-4">
                              <v-icon>mdi-airplane-landing</v-icon> Land
                            </v-btn>
                            <time v-else-if="flight.status === 4" class="land">{{flight.land_time ? flight.land_time : ' --:--' }}</time>
                          </v-col>

                         <v-col @click="dropJump(flight)">
                             <v-chip-group
                              column :class="{ landed_group : flight.status === 4 || flight.status < 1 }"
                              active-class="primary--text"

                                                     >
                              <v-chip :disabled="!viewingToday" close  v-for="(assigned_jump, j) in flight.assigned_jumps" :key="assigned_jump.jumpId"

                              @click:close="remove_jump(flight.id, assigned_jump.jumpId, f)"
                              >
                                <span>  <strong>{{assigned_jump.code}}</strong>
                                  {{ assigned_jump.fullName }} <small>{{ assigned_jump.customerW }}</small> <br>
                                    {{ assigned_jump.instructorName }} <small>{{ assigned_jump.instructorW }}</small>

                                </span>

                              </v-chip>
                              </v-chip-group>
                           </v-col>
                      </v-row>

                    <v-row>
                      <v-col>
                        <p><strong>Notes:</strong> {{flight.notes}} <v-btn :disabled="!viewingToday && !checkGate('load-undo')" icon depressed small @click="edit(flight)">
                              <v-icon center>mdi-pencil</v-icon>
                            </v-btn ></p>
                      </v-col>
                    </v-row>

                    <v-card-actions>

                        Total Weight: {{

                        flight.assigned_jumps ?


                        sum(flight.assigned_jumps,'instructorW') + sum(flight.assigned_jumps,'customerW') + flight.pilotWeight : flight.pilotWeight
                                        }}
                          <v-spacer></v-spacer>
                          <v-btn v-if="flight.status === 1 && (flight.assigned_jumps === null || flight.assigned_jumps.length === 0)" small class="red--text"
                          @click="del(flight.id)"><v-icon>mdi-delete-forever</v-icon> Delete</v-btn>
                    </v-card-actions>

                  </v-card>

              </v-item>

              </v-col>

        </v-row>

          </v-item-group>

        </v-card>
      </v-col>
    </v-row>

    <DayPicker @reloadData="loadData"/>

  </v-container>

</template>

<style>
.v-bottom-sheet.v-dialog { overflow-y: scroll; }

.v-avatar h3 { margin-bottom: 0 }

.v-bottom-sheet h2 { display: inline; }

.load-summary { list-style: none; display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 1em }

.v-card .v-list-item div {
  list-style: none; text-align: left; padding-left: 0; width: 100% }

.v-list-item em { font-weight: bold; font-style: normal;  float: left; margin-right: 1%; }

 .selectedJumps .v-list-item span { display: block; }
   span.instructorName { font-style: italic;  }

   .checkedin .v-list-item { padding: 0 }
.container.container--fluid { padding-left:  0; padding-right: 0 }


@media (min-width: 1200px) {

  .container {
      max-width: 1400px;
  }

}


@media (max-width: 678px) {

  .fixed-bar { height: auto!important; background-color: #ccc; }

.load-summary { grid-template-columns: repeat(2, 1fr)  }

}

.load_info {
  text-align: left;
}
.load_info span, .load_info time { display: block; text-align: left; }

.load_info .v-chip__content { font-weight: bold }

time { display: block; text-align: left;  line-height: 1.5; padding: 0.5em 0 }

.load_info span:before, time:before {
    font-size: 83%;
    top: -5px;
}
.load_info li { width: 50%;  }

.depart:before { content: "Departed: " }
.land:before { content: "Landed: " }


.v-slide-group__content { border: 1px dotted #FFFFFF }

.v-slide-group__content:empty, .v-slide-group__content:empty:hover{ min-height: 4vh;    }

.v-slide-group__content:empty:before, .v-slide-group__content:empty:hover {  content: "Click here to drop a jumper"; color: #999; text-indent: 1em; }

.deep-purple .v-slide-group__content:empty:before { color: #FFFFFF }


.load-title .v-toolbar__title { color: #FFFFFF }


.float-right { float: right; }

.v-chip.v-size--default { height: inherit; }

.v-card p { text-align: left; }

h4 .v-btn:not(.v-btn--round).v-size--small { min-width: auto; padding: 0 3px; }

h4 { text-align: right; }

.landed_group button.v-chip__close { display: none; }
.landed_group .v-chip--disabled { opacity: 1 }

.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 6em;
  z-index: 2;
}

.selectedJumps.fixed-bar {
  top: 12em;
}
.v-item-group .col-12.minified.hidden {
  display: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 600ms, visibility 600ms;
}

.v-item-group .col-12.minified {
  display: block;
  opacity: 1;
  visibility: visible;

}
</style>

<script>
import { mapState, mapActions } from 'vuex'
import StatusChip from '../components/StatusChip.vue'
import DayPicker from '../components/DayPicker.vue'
import ManifestbyInstructorView from "../components/ManifestbyInstructorView.vue";

  export default {
    components: {

      StatusChip, DayPicker, ManifestbyInstructorView
    },
        data() {
            return {

              dialog: false,
              selectInstructorBox: false,
              listView: false,
              //Form:
                valid : true,
                validInstructor : false,

                pilotRules:[
                        v => !!v || 'A Pilot must be selected',
                      ],
                plainRules:[
                        v => !!v || 'An Aircraft must be selected',
                      ],
                instructorRules:[
                        v => !!v || 'Please select an Instructor',
                      ],


                editedIndex: -1,
                editedItem: {
                  number : 0,

                  plain_id : 0,
                  pilot_id : 0,
                  status : 1,

                  departed_time : '',
                  land_time : '',
                  total_weight : 0,
                  //canopies : 0,
                  notes : '',
                  assigned_jumps : [],
                  expand : true

                },

                selectedJumps : null,
                activeLoad : null,
                selectedFlight : null,
                flightInstructorsIDs : [],

                jump : {
                  jumpId : 0,
                  code : '',
                  fullName : '',
                  customerW : 0,
                  instructorName : '',
                  instructorW : '',
                  selectedInstructor: null,
                  flightId : null
                },

                snackbar : false,
                snackbartext : '',

                landedLoadsSheet: false,
                viewingToday :true,
                viewJumpersList : true,
                sendingEmail : false,
        }
      },

        mounted () {
            this.$store.dispatch('fetchManifestData')
            this.$store.dispatch('reloadManifest')
            this.$store.dispatch('reloadCheckedIn')

            if ( this.instructors.length === 0)
            this.$store.dispatch('fetchInstructors')


        },

        computed : {

            ...mapState(['checkedin']),
            ...mapState(['plains']),


            pilots() {
              return this.$store.getters.activePilots

            },


            instructors() {

              return this.$store.getters.activeInstructors

            },


            flights() {

              const viewingToday = this.viewingToday
              this.$store.state.flights.forEach(function (f) {

                  if ( (f.status !== 4 && viewingToday) || !viewingToday )
                  f.expand = true

                })

              return this.$store.state.flights

            },


            landedloads () {

                const viewingToday = this.viewingToday
               return this.flights.filter(function(f) {
                return f.status === 4 && viewingToday

              })


            },


            filteredInstructors() {
              return this.instructors.filter((el) => {

                return !this.flightInstructorsIDs.includes(el.id)
              })
            },


        },

        watch: {

          dialog (val) {
            val || this.close()
            },


        },



        methods: {

            ...mapActions(['getFlightsbyDate']),

          dropJump(flight) {


            if ( flight.status !== 1 && flight.status !== 3 ) {
              this.snackbartext = 'Select a working Load'
              this.snackbar = true;
                          return
            }


            if ( typeof this.selectedJumps !== 'undefined' && this.selectedJumps !== null ) {
              //console.log("this.selectedJumps", this.selectedJumps)


              this.jump = this.checkedin[this.selectedJumps]
              var assignedJumps =  flight.assigned_jumps !== null ? flight.assigned_jumps : []


            if (this.jump !== undefined) {

                if ( this.jump.instructorName === null ) {

                      this.jump.flightId =  flight.id
                      this.selectInstructorBox = true

                      if (assignedJumps.length > 0 ) {
                        this.flightInstructorsIDs = []
                        this.flightInstructorsIDs = this.getflightInstructors(assignedJumps)
                      }


                    } else {

                      //If the Instructor is Already on the Load..
                      if (assignedJumps.length > 0 && this.getflightInstructors(assignedJumps).includes(this.jump.instructorId)) {

                          this.snackbartext = jump.instructorName + 'is already in that Load'
                          this.snackbar = true;

                      } else {


                        this.assignJumps(flight.id)

                      }
               }

            }




            }

          },



          getColor(status) {

                  if (status < 1 )

                  return "red darken-2"

                if ( status <= 2 )

                  return "yellow darken-2"

                  if ( status === 3 )

                  return "green darken-2"

                if ( status === 4 )

                  return "blue"

          },


          getflightInstructors(jumps){

            return jumps.map( function (j) {
              return j.instructorId
            })

          },

          assignInstructor() {

              axios.post('/api/jumps/assignInstructor/' + this.jump.jumpId, this.jump)
                    .then( response => {

                      this.selectInstructorBox = false
                      this.$store.dispatch('reloadManifest')
                            this.selectedJumps = null
                            this.activeLoad = null

                    }).catch( err => {
                        console.log( err )
                    })


          },

          closeInstBox() {


            this.selectInstructorBox = false
                this.$nextTick(() => {

                  this.jump = Object.assign({}, this.defaultItem)


                })

          },

          removeInstructor(jump){

            confirm('Remove Tandemed Instructor?') &&
            axios.post('/api/jumps/removeInstructor/' + jump.jumpId)
                    .then( response => {


                             this.$store.dispatch('reloadCheckedIn')
                            this.activeLoad = null

                    })
                    .catch( err => {
                        console.log( err )
                    })

          },


          assignJumps(fligthId) {

                  var jumpIds = [];
                  jumpIds.push(this.checkedin[this.selectedJumps]);



              axios.post('/api/jumps/assign/' + fligthId, jumpIds)
                    .then( response => {


                             this.$store.dispatch('reloadManifest')
                            this.selectedJumps = null
                            this.activeLoad = null

                    })
                    .catch( err => {
                        console.log( err )
                    })

          },


          edit(item) {

            this.editedIndex = this.flights.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
                this.selectInstructorBox = false
          },


          save() {

            if (this.editedIndex > -1) {


                     axios.put('/api/flights/' + this.editedItem.id, this.editedItem)
                        .then( response => {



                          this.$store.dispatch('getFlightsbyDate','today').then(() => {
                              this.close()
                            });

                        })
                        .catch( err => {
                            console.log( err )
                        })


                } else {


                     this.$store.dispatch('getFlightsbyDate','today').then(() => {

                         const lastIndex = this.flights.length

                         this.editedItem.number = lastIndex > 0 ? this.flights[lastIndex - 1].number + 1 : 1

                        axios.post('/api/flights', this.editedItem)
                        .then( response => {

                            this.$store.dispatch('getFlightsbyDate','today').then(() => {
                                  this.close()
                                })

                        })
                        .catch( err => {
                            console.log( err )
                        })
                    })

                }

          },

            close () {
                this.dialog = false
                this.$nextTick(() => {

                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1

                })
              },




              remove_jump(flightId, jumpId, activeLoad) {

                axios.post('/api/jumps/unassign/' + flightId, { "jumpId": jumpId })
                    .then( response => {


                            this.$store.dispatch('reloadManifest').then(() => {


                              const index = this.checkedin.map(function (jump) { return jump.jumpId; }).indexOf(jumpId)

                              this.selectedJumps = index;
                              });




                    })
                    .catch( err => {
                        console.log( err )
                    })

              },

              depart(flightId) {

                axios.put('/api/flights/depart/' + flightId)
                        .then( response => {
                          const index = this.flights.map(function (f) { return f.id; }).indexOf(flightId)
                            this.$store.state.flights[index].status = 3
                            this.$store.state.flights[index].departed_time = response.data.departed_time
                        })
                        .catch( err => {
                            console.log( err )
                        })

              },

              land(flightId) {

                this.sendingEmail = true

                axios.put('/api/flights/land/' + flightId)
                        .then( response => {


                            const index = this.flights.map(function (f) { return f.id; }).indexOf(flightId)

                            this.$store.state.flights[index].status = 4
                            this.$store.state.flights[index].expand = false

                            this.$store.state.flights[index].land_time = response.data.land_time
                            this.sendingEmail = false

                        })
                        .catch( err => {
                            console.log( err )
                        })

              },

              unland(flightId) {

                axios.put('/api/flights/unland/' + flightId)
                        .then( response => {


                            const index = this.flights.map(function (f) { return f.id; }).indexOf(flightId)

                            this.$store.state.flights[index].status = 3
                            this.$store.state.flights[index].expand = true

                            this.$store.state.flights[index].land_time = ""

                        })
                        .catch( err => {
                            console.log( err )
                        })

              },

              cancel(flightId) {

                //confirm('Are you sure you want to cancel this Load?') &&

                  const reason = prompt('Cancellation Reason:','Weather')

                  if (reason) {
                      axios.put('/api/flights/cancel/' + flightId, { 'notes' : reason})
                          .then(response => {
                              console.log(response.data)

                              const index = this.flights.map(function (f) {
                                  return f.id;
                              }).indexOf(flightId)
                              
                              this.$store.state.flights[index].status = response.data.status
                              this.$store.state.flights[index].notes = response.data.notes
                          })
                          .catch(err => {
                              console.log(err)
                          })
                  }
              },

              del(flightId) {

                confirm('Are you sure you want to delete this Load? This action can not be undone') &&

                axios.delete('/api/flights/' + flightId)
                        .then( response => {

                            const index = this.flights.map(function (f) { return f.id; }).indexOf(flightId)

                            this.$store.state.flights[index].status = response.status
                            this.$store.state.flights.splice(index, 1)
                        })
                        .catch( err => {
                            console.log( err )
                        })
              },

              hide(flight) {

                flight.expand = false

                //if ("this.viewingToday")
                this.landedloads.push(flight)

              },

              maximize(flightId) {

                const allIndex = this.flights.map(function (f) { return f.id; }).indexOf(flightId)
                const minifiedIndex = this.landedloads.map(function (f) { return f.id; }).indexOf(flightId)

                this.activeLoad = allIndex
                this.flights[allIndex].expand = true
                                this.landedloads.splice(minifiedIndex, 1)

                                //console.log(this.landedloads.length)
                this.landedLoadsSheet = false;
              },


              loadData(day) {


                const date = new Date(day + "T00:00:00")

                this.viewingToday = date.isToday() ? true : false
                this.$store.dispatch('getFlightsbyDate', day)

                this.viewJumpersList = false
                this.selectedJumps = null

          },

        }
    }
</script>
